<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show">
                    <v-toolbar dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Nueva Obligación Periódica Legal o de Otro
                            Tipo</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="2">
                                <v-select dense v-model="aspecto" :items="aspectos" label="Aspecto" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="6">
                                <v-text-field label="Obligación" dense v-model="obligacion">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-select dense v-model="tipo" :items="tipos" label="Tipo" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <v-select dense v-model="alcance" :items="alcances" label="Alcance" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Norma" dense v-model="norma">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Título" dense v-model="titulo">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Localización" dense v-model="localizacion">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Materia" dense v-model="materia">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Frecuencia" dense v-model="frecuencia">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Fecha últ. actualización" dense v-model="fecha">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="resp" :items="responsables" label="Responsable"
                                    item-text="detalle" item-value="valor"></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field label="Norma Técnica" dense v-model="normatec">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-select dense v-model="estado" :items="estados" label="Estado" item-text="detalle"
                                    item-value="valor"></v-select>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea label="Observaciones" dense rows="2" auto-grow v-model="observ">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth.js";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        codgral: "",
        resp: "",
        aspecto: "",
        obligacion: "",
        estado: "A",
        norma: "",
        normatec: "",
        alcance: "",
        fecha: "",
        fechavenc: "",
        frecuencia: "",
        titulo: "",
        localizacion: "",
        materia: "",
        observ: "",
        tipo: "",
        deshabilitar: false,
        estados: [{ detalle: "Activa", valor: "A" },
        { detalle: "Inactiva", valor: "I" },
        ],
        tipos: [{ detalle: "Legal", valor: "L" },
        { detalle: "Registro", valor: "R" },
        { detalle: "Otro", valor: "O" },
        ],
        alcances: [{ detalle: "Nacional", valor: "Nacional" },
        { detalle: "Provincial", valor: "Provincial" },
        { detalle: "Municipal", valor: "Municipal" },
        { detalle: "Nacional, Provincial y Municipal", valor: "Nacional, Provincial y Municipal" },
        ],
        aspectos: [{ detalle: "Medio Ambiente", valor: "M" },
        { detalle: "SST", valor: "S" },
        { detalle: "Clientes y Registros", valor: "C" },
        { detalle: "Legales y Societarios", valor: "L" },
        { detalle: "Otros", valor: "O" },
        ],
        responsables: [{ detalle: "AGNOLON Fernando", valor: "AGNOLON Fernando" },
        { detalle: "BLANCO Sergio", valor: "BLANCO Sergio" },
        { detalle: "DEMICHELIS Leonardo", valor: "DEMICHELIS Leonardo" },
        { detalle: "GRUBESIC Monica", valor: "GRUBESIC Monica" },
        { detalle: "MANSUR Cecilia", valor: "MANSUR Cecilia" },
        { detalle: "MOLINARI Marcelo", valor: "MOLINARI Marcelo" },
        { detalle: "MONTENEGRO Sonia", valor: "MONTENEGRO Sonia" },
        { detalle: "MUSSO Marcos", valor: "MUSSO Marcos" },
        { detalle: "OFICINA DE PERSONAL", valor: "OFICINA DE PERSONAL" },
        { detalle: "PRIETO Maria Luisa", valor: "PRIETO Maria Luisa" },
        ],

    }),
    computed: {
        show: {
            get() {
                this.cargarcodigo();
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargarcodigo() {
            let self = this;
            axios
                .get("/Sgi/CodigoObligacion?")
                .then((response) => {
                    self.codgral = response.data;
                    console.log(self.codgral);
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Guardar Obligación",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.fechavenc = moment(this.fecha, 'DD/MM/YYYY').add(this.frecuencia, 'months').format('DD/MM/YYYY');
                    console.log("fecha venc", this.fechavenc)
                    var datos = {
                        codgral: this.codgral,
                        aspecto: this.aspecto,
                        alcance: this.alcance,
                        norma: this.norma,
                        normatec: this.normatec,
                        obligacion: this.obligacion,
                        localizacion: this.localizacion,
                        frecuencia: this.frecuencia,
                        tipo: this.tipo.valor,
                        responsable: this.resp,
                        fecha: this.fecha,
                        materia: this.materia,
                        titulo: this.titulo,
                        estado: this.estado,
                        observ: this.observ,
                        fechavenc: this.fechavenc,
                    };
                    let self = this;
                    axios
                        .post("/SGI/GuardarObligacion", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Obligación guardada con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
        vaciarModels() {
            this.codgral = "";
            this.resp = "";
            this.aspecto = "";
            this.obligacion = "";
            this.estado = "A";
            this.norma = "";
            this.normatec = "";
            this.alcance = "";
            this.fecha = "";
            this.frecuencia = "";
            this.titulo = "";
            this.localizacion = "";
            this.materia = "";
            this.observ = "";
            this.tipo = "";
            this.deshabilitar = false;
        },
    },
}
</script>
